<template>
    <va-edit-layout>
        <RentalTransactionEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></RentalTransactionEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
